// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import { PlasmicWebTheIndependent } from "./plasmic/o_21_p_0_0_0_prod/PlasmicWebTheIndependent";
import { Helmet } from "react-helmet-async";

function WebTheIndependent_(props, ref) {
  return (
      <>
        <Helmet>
          <title>the independent.</title>
          
  
          <link rel="icon" type="image/x-icon" href="%PUBLIC_URL%/favicon2.ico" />
          <meta property="og:title" content="the independent." />
          <meta property="og:description" content="The independent is the individual who treats work as personal expression, builds a personal system to do it on his or her terms, and assumes direct responsibility for the decisions, standards, and outcomes that shape the work as it reaches others." />
          <meta property="og:url" content="https://o21p.com/the-independent" />
          <link
            rel="shortcut icon"
            href="%PUBLIC_URL%/favicon2.ico"
            type="image/x-icon"
          />
  
          <link
            rel="apple-touch-icon"
            href="%PUBLIC_URL%/apple-touch-icon.png"
          />
          <link
            rel="apple-touch-icon"
            sizes="57x57"
            href="%PUBLIC_URL%/apple-touch-icon-57x57.png"
          />
          <link
            rel="apple-touch-icon"
            sizes="72x72"
            href="%PUBLIC_URL%/apple-touch-icon-72x72.png"
          />
          <link
            rel="apple-touch-icon"
            sizes="76x76"
            href="%PUBLIC_URL%/apple-touch-icon-76x76.png"
          />
          <link
            rel="apple-touch-icon"
            sizes="114x114"
            href="%PUBLIC_URL%/apple-touch-icon-114x114.png"
          />
          <link
            rel="apple-touch-icon"
            sizes="120x120"
            href="%PUBLIC_URL%/apple-touch-icon-120x120.png"
          />
          <link
            rel="apple-touch-icon"
            sizes="144x144"
            href="%PUBLIC_URL%/apple-touch-icon-144x144.png"
          />
          <link
            rel="apple-touch-icon"
            sizes="152x152"
            href="%PUBLIC_URL%/apple-touch-icon-152x152.png"
          />
          <link
            rel="apple-touch-icon"
            sizes="180x180"
            href="%PUBLIC_URL%/apple-touch-icon-180x180.png"
          />
        </Helmet>
  
        <PlasmicWebTheIndependent root={{ ref }} {...props} />
      </>
    );
}

const WebTheIndependent = React.forwardRef(WebTheIndependent_);

export default WebTheIndependent;
